import React from 'react';
import { emptyFunction } from '../../../core/util/function';
import Header911Section from './Header';
import BottomSection from './BottomSection/Desktop';
import MiddleSection from './MiddleSection/Desktop';

type Props = {
  show911Section?: boolean;
  showMiddleSection?: boolean;
  showBottomSection?: boolean;
  showSocial?: boolean;
  showHIPAAAuthorization?: boolean;
};

const Desktop = (props: Props) => {
  const {
    show911Section = true,
    showMiddleSection = true,
    showBottomSection = true,
    showSocial = true,
    showHIPAAAuthorization = true,
  } = props;

  return (
    <>
      {show911Section && <Header911Section />}
      {showMiddleSection && <MiddleSection />}
      {showBottomSection && (
        <BottomSection showHIPAAAuthorization={showHIPAAAuthorization} showSocial={showSocial} />
      )}
    </>
  );
};

export default Desktop;
